import { Injectable } from "@angular/core";
import { Status } from "@core/data";
import { ReportComponentType } from "@core/data/types/advanced-report";
import { Action, State, StateContext } from "@ngxs/store";

export interface ReportComponentFormStateModel {
    key: string;
    status: Status;
    type: ReportComponentType;
}

const DEFAULTS: ReportComponentFormStateModel = {
    key: null,
    status: Status.UNINITIALIZED,
    type: ReportComponentType.UNSET,
}

export class InitReportComponentForm {
    static readonly type = "[ReportComponent] Init"
    constructor(
        public type?: ReportComponentType,
    ) {}
}

@State({
    name: "report_component_form",
    defaults: DEFAULTS,
})
@Injectable()
export class ReportComponentFormState {

    constructor(

    ) {}

    @Action(InitReportComponentForm)
    initReportComponent(ctx: StateContext<ReportComponentFormStateModel>, action: InitReportComponentForm) {
        ctx.setState(DEFAULTS);

        ctx.patchState({
            status: Status.OK,
            type: action.type,
        });


    }
}